import { NotifyPeopleModalRoot } from 'hb-react/frontoffice/components/NotifyPeopleModal';

import { type UserTargetingProps } from './types';

const UserTargeting = ({
  baseQuery,
  defaultSelectedUsers,
  ...props
}: UserTargetingProps) => (
  <NotifyPeopleModalRoot
    baseQuery={baseQuery}
    defaultSelectedUsers={defaultSelectedUsers}
    {...props}
  />
);

export default UserTargeting;
